<template>
	<v-container fluid >
		<div class="bottom-buttons-outer">
			<v-btn @click="saveClick" color="success">
				<v-icon small>fa-save</v-icon>&nbsp;{{$t('buttons.save')}}
			</v-btn>
		</div>
		<v-layout row wrap>
			<v-flex lg8 xs12>
				<v-card>
					<v-card-text>
						<v-layout row wrap>
							<v-flex xs12>
								<InputField :error="userValidation.first_name"
											:label="$t('fields.firstName')"
											v-model="user.first_name"></InputField>
							</v-flex>
							<v-flex xs12>
								<InputField
										:error="userValidation.last_name"
										:label="$t('fields.lastName')"
										v-model="user.last_name"></InputField>
							</v-flex>
							<v-flex xs12>
								<InputField
										:error="userValidation.email"
										:label="$t('fields.email')"
										v-model="user.email"></InputField>
							</v-flex>
							<v-flex xs12>
								<CheckBox
										:label="$t('fields.passwordChange')"
										v-model="user.password_change"></CheckBox>
							</v-flex>
							<template v-if="user.password_change">
								<v-flex xs12>
									<InputField
											:error="userValidation.old_password"
											:label="$t('fields.oldPassword')"
											:type="'password'"
											v-model="user.old_password"></InputField>
								</v-flex>
								<v-flex md6 xs12>
									<InputField
											:error="userValidation.new_password"
											:label="$t('fields.newPassword')"
											:type="'password'"
											v-model="user.new_password"></InputField>
								</v-flex>

								<v-flex md6 xs12>
									<InputField
											:error="userValidation.new_password_confirmation"
											:label="$t('fields.newPasswordConfirmation')"
											:type="'password'"
											v-model="user.new_password_confirmation"></InputField>
								</v-flex>
							</template>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
	import InputField from "./trinkets/InputField"
	import CheckBox from "./trinkets/CheckBox";

	export default {
		name: "Profile",
		components: {CheckBox, InputField},
		data: function () {
			return {
				user: {
					first_name: '',
					last_name: '',
					email: '',
					oib: '',
					password_change: false,
					old_password: '',
					new_password: '',
					new_password_confirmation: ''
				},
				userValidation: {
					first_name: '',
					last_name: '',
					email: '',
					oib: '',
					old_password: '',
					new_password: '',
					new_password_confirmation: ''
				}
			}
		},
		methods: {
			backClick() {
				this.$router.push('/dashboard');
			},
			saveClick() {

				let success = true;

				if (this.user.first_name == '') {
					success = false;
					this.userValidation.first_name = this.$t('alerts.fieldError');
				} else {
					this.userValidation.first_name = '';
				}

				if (this.user.last_name == '') {
					success = false;
					this.userValidation.last_name = this.$t('alerts.fieldError');
				} else {
					this.userValidation.last_name = '';
				}

				if (this.user.email == '') {
					success = false;
					this.userValidation.email = this.$t('alerts.fieldError');
				} else {
					if (!this.$checkEmail(this.user.email)) {
						success = false;
						this.userValidation.email = this.$t('alerts.fieldError');
					} else {
						this.userValidation.email = '';
					}
				}

				if (this.user.password_change) {
					if (this.user.old_password.trim() == '') {
						success = false;
						this.userValidation.old_password = this.$t('alerts.fieldError');
					} else {
						this.userValidation.old_password = '';
					}

					if (this.user.new_password.trim() == '') {
						success = false;
						this.userValidation.new_password = this.$t('alerts.fieldError');
					} else {
						if (this.user.new_password.length < 8) {
							this.userValidation.new_password = this.$t('alerts.passwordLength');
						} else {
							this.userValidation.new_password = '';
						}
					}

					if (this.user.new_password != this.user.new_password_confirmation) {
						success = false;
						this.userValidation.new_password_confirmation = this.$t('alerts.fieldError');
					} else {
						this.userValidation.new_password_confirmation = '';
					}
				} else {
					this.userValidation.old_password = '';
					this.userValidation.new_password = '';
					this.userValidation.new_password_confirmation = '';
				}

				if (success) {
					let vm = this;
					this.$APICall('put', 'users/' + this.$myStore.state.user.id, this.user, (data, success) => {
						if (success) {
							vm.$notify(vm.$t('alerts.basicUpdate'));
						} else {
							if (vm.user.password_change) {
								vm.$alert(vm.$t('alerts.oldPasswordFail'));
							} else {
								vm.$alert(vm.$t('alerts.basicError'));
							}
						}
					});
				}
			}
		},
		mounted() {
			if (!this.$myStore.state.loggedIn) {
				this.$router.replace('login');
			}
			this.$setSubMenu('Settings');
			this.$myStore.commit('setBreadcrumbs', [
				{text: this.$t('modules.profile'), href: '/#/profile', disabled: true}
			]);
			let vm = this;
			this.$APICall('get', 'users/' + this.$myStore.state.user.id, {}, (data, success) => {
				if (success) {
					let userData = data;
					userData.password_change = false;
					userData.old_password = '';
					userData.new_password = '';
					userData.new_password_confirmation = '';
					vm.user = userData;
				}
			});
		}
	}
</script>

<style scoped>

</style>
